// IMPORTS
// Modules
import { useState, useLayoutEffect } from 'react';
// Assets
import './../scss/OHSPopup.scss';
import icon_info from './../icons/information_dark.svg';
import icon_success from './../icons/checkmark_dark.svg';
import icon_warning from './../icons/exclamation_dark.svg';
import icon_error from './../icons/error_dark.svg';
import icon_cancel from './../icons/cancel_dark.svg';


// COMPONENT
export default function OHSPopup (props) {
   // States and Variables
   const [timer, setTimer] = useState(null);

   // On-Load
   useLayoutEffect(function () {
      if ((props.popup.display === true) && (props.popup.timespan) && (props.popup.timespan !== null)) {
         autoClosePopup();
      } else {
         clearTimeout(timer);
      }
   }, [props.popup]);

   // Functions
   const autoClosePopup = function () {
      setTimer(setTimeout(function () {
         props.setPopup({
            display: false,
            title: null,
            message: null,
            severity: null,
            timespan: null
         });
      }, (props.popup.timespan * 1000)));
   }
   const closePopup = function () {
      props.setPopup({
         display: false,
         title: null,
         message: null,
         severity: null,
         timespan: null
      });
   }

   // Component
   return (
      <>
         {props.popup.display && 
            <div className={`ohspopup ohspopup-${props.popup.severity}`}>
               <div className='ohspopup-left'>
                  {props.popup.severity === null && <img src={icon_info} alt="Information Icon" />}
                  {props.popup.severity === 'info' && <img src={icon_info} alt="Information Icon" />}
                  {props.popup.severity === 'success' && <img src={icon_success} alt="Success Icon" />}
                  {props.popup.severity === 'warning' && <img src={icon_warning} alt="Warning Icon" />}
                  {props.popup.severity === 'noauth' && <img src={icon_warning} alt="Warning Icon" />}
                  {props.popup.severity === 'error' && <img src={icon_error} alt="Error Icon" />}
               </div>
               <div className='ohspopup-right'>
                  <div className='ohspopup-right-header'>
                     <p>{props.popup.title && props.popup.title.length > 0 ? props.popup.title : "Message"}</p>
                     <img src={icon_cancel} alt='Cancel Icon' onClick={closePopup} />
                  </div>
                  <hr />
                  <div className='ohspopup-right-body'>
                     <p>{props.popup.message && props.popup.message.length > 0 ? props.popup.message : "No information available."}</p>
                  </div>
               </div>
            </div>
         }
      </>
   );
}